<template>
  <div>
    <Search />
    <div style="height:112px;width:100%;" />
    <div class="wrapper-box" style="height: 300px">
      <img src="../assets/imgs/icon_success.png">
      <div class="wrapper-text">
        <span style="font-weight: bold; font-size: 24px">{{ title }}</span>
        <span style="font-size: 14px">{{ content }}</span>
      </div>
    </div>
    <div class="wrapper-box">
      <Button
        class="suc-btn"
        style="
          color: #518ef7;
          background-color: #fff;
          border: 1px solid #518ef7;
        "
        size="large"
        @click="toHome"
      >返回首页</Button>
      <Button
        class="suc-btn"
        style="
          color: #fff;
          background-image: linear-gradient(#61abf6, #518ef7);
          margin-left: 20px;
        "
        size="large"
        @click="toOrder"
      >查看订单</Button>
    </div>
    <p style="width:75%;margin:auto;font-weight:bold;font-size:16px;margin-top:55px">可以顺便看看以下其他商品哦~</p>
    <div class="goods-list">
      <router-link
        v-for="(item, index) in orderGoodsList"
        :key="index"
        :to="{ path: '/goodsDetail', query: { id: item.id } }"
      >
        <div class="goods-show-info">
          <div class="goods-show-img">
            <img class="goods-pic" :src="item.pic">
          </div>
          <div class="goods-show-price">
            <span>
              <Icon type="social-yen text-danger" />
              <span class="seckill-price text-danger">{{ item.price }}</span>
            </span>
          </div>
          <div class="goods-show-detail">
            <span>{{ item.name }}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
import { searchProductList } from '@/api/product.js'

export default {
  name: 'SuccessPage',
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0)
    next()
  },
  components: {
    Search
  },
  data() {
    return {
      title: '提交成功！',
      content: '订单提交成功，请等待审核',
      orderGoodsList: []
    }
  },
  mounted() {
    if (this.$route.params.from && this.$route.params.from === 'pay') {
      this.title = '支付成功!'
      this.content = '订单支付成功！'
    }
    searchProductList({
      pageNum: 1,
      pageSize: 8,
      sort: 2
    }).then((res) => {
      if (res.code === 200) {
        this.orderGoodsList = res.data.list
      }
    })
  },
  methods: {
    toHome() {
      this.$router.replace('/')
    },
    toOrder() {
      if (this.$route.params.id) {
        this.$router.replace(`/home/auditDetail?id=${this.$route.params.id}`)
      } else {
        this.$router.replace(`/home/myOrder`)
      }
    }
  }
}
</script>

<style scoped>
.wrapper-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrapper-text {
  display: flex;
  flex-direction: column;
  margin-left: 40px;
}
.suc-btn {
  width: 120px;
  height: 48px;
}
/* 商品栏开始 */
.goods-pic {
  width: 220px;
  height: 220px;
}
.goods-list {
  width: 75%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.goods-show-info {
  width: 240px;
  padding: 10px;
  margin: 15px 0px;
  border: 1px solid #fff;
  cursor: pointer;
}
.goods-show-info:hover {
  border: 1px solid #ccc;
  box-shadow: 0px 0px 15px #ccc;
}
.goods-show-price {
  margin-top: 6px;
}
.goods-show-detail {
  font-size: 12px;
  margin: 6px 0px;
}
.goods-show-num {
  font-size: 12px;
  margin-bottom: 6px;
  color: #009688;
}
.goods-show-num span {
  color: #005aa0;
  font-weight: bold;
}
.goods-show-seller {
  font-size: 12px;
  color: #e4393c;
}
.goods-page {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
